import React, { Suspense } from "react";
import {
  authRoutes,
  publicRoutes,
  protectedRoutes,
} from "./allRoutes";
import { Route, Routes } from "react-router-dom";

const CommonLayout = React.lazy(() => import("../Layout/CommonLayout/index"));
const AuthLayout = React.lazy(() => import("../Layout/AuthLayout"));
const ProtectedRoute = React.lazy(() =>
  import("../Layout/ProtectedRoute")
);
const PublicRoute = React.lazy(() =>
  import("../Layout/PublicRoute")
);

const Loader = () => {
  return (
    <div id="preloader">
      <div id="status">
        <ul>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
      </div>
    </div>
  );
};

const Index = () => {
  return (
    <React.Fragment>
      <Suspense fallback={Loader()}>
        <Routes>
          {/* Rotas de Autenticação (SignIn, SignUp) - só para não autenticados */}
          <Route>
            {authRoutes.map((route, idx) => (
              <Route
                path={route.path}
                element={
                  <AuthLayout>
                    <PublicRoute>{route.component}</PublicRoute>
                  </AuthLayout>
                }
                key={idx}
                exact={true}
              />
            ))}
          </Route>

          {/* Rotas Públicas (acessíveis por todos) */}
          <Route>
            {publicRoutes.map((route, idx) => (
              <Route
                path={route.path}
                element={<CommonLayout>{route.component}</CommonLayout>}
                key={idx}
                exact={true}
              />
            ))}
          </Route>

          {/* Rotas Protegidas (requerem autenticação) */}
          <Route>
            {protectedRoutes.map((route, idx) => (
              <Route
                path={route.path}
                element={
                  <CommonLayout>
                    <ProtectedRoute>{route.component}</ProtectedRoute>
                  </CommonLayout>
                }
                key={idx}
                exact={true}
              />
            ))}
          </Route>
        </Routes>
      </Suspense>
    </React.Fragment>
  );
};

export default Index;
